/**
 * Who We Serve Block JavaScript - Tabs with GSAP Animations
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initWhoWeServe() {
    const blocks = document.querySelectorAll(".who-we-serve");

    blocks.forEach((block) => {
      const tabs = block.querySelectorAll(".vertical_tab .vertical_tab_title");
      const imageContainers = block.querySelectorAll(".image_container");
      const tabContentItems = block.querySelectorAll(".tab_content_item");
      const largeImageContainers = block.querySelectorAll(
        ".large_image_container"
      );

      if (tabs.length === 0) return;

      const updateTabAccessibility = (activeIndex) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === activeIndex;
          tab.classList.toggle("active", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
          tab.setAttribute("tabindex", isActive ? "0" : "-1");
          tab.closest(".vertical_tab")?.classList.toggle("active", isActive);
        });

        tabContentItems.forEach((panel, panelIndex) => {
          const isActive = panelIndex === activeIndex;
          if (isActive) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      };

      // Function to switch tabs with GSAP animation
      const switchTab = (index) => {
        updateTabAccessibility(index);

        // Fade out all content
        const allContent = [
          ...imageContainers,
          ...tabContentItems,
          ...largeImageContainers,
        ];

        if (window.gsap) {
          // Fade out current content
          window.gsap.to(allContent, {
            opacity: 0,
            duration: 0.3,
            ease: "power2.out",
            onComplete: () => {
              // Remove active class from all content
              allContent.forEach((item) => item.classList.remove("active"));

              // Add active class to new content
              imageContainers[index]?.classList.add("active");
              tabContentItems[index]?.classList.add("active");
              largeImageContainers[index]?.classList.add("active");

              // Get the newly active items
              const newContent = [
                imageContainers[index],
                tabContentItems[index],
                largeImageContainers[index],
              ].filter(Boolean);

              // Fade in new content with stagger
              window.gsap.fromTo(
                newContent,
                { opacity: 0, y: 20 },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.6,
                  stagger: 0.1,
                  ease: "power2.out",
                }
              );
            },
          });
        } else {
          // Fallback without GSAP
          allContent.forEach((item) => item.classList.remove("active"));
          imageContainers[index]?.classList.add("active");
          tabContentItems[index]?.classList.add("active");
          largeImageContainers[index]?.classList.add("active");
        }

        console.log("[BLOCK] Switched to tab", index);
      };

      // Add click handlers to tabs
      tabs.forEach((tab, index) => {
        tab.addEventListener("mouseover", () => {
          switchTab(index);
        });

        tab.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            switchTab(index);
            return;
          }

          let nextIndex = null;

          if (e.key === "ArrowDown" || e.key === "ArrowRight") {
            nextIndex = (index + 1) % tabs.length;
          } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (e.key === "Home") {
            nextIndex = 0;
          } else if (e.key === "End") {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            e.preventDefault();
            switchTab(nextIndex);
            tabs[nextIndex].focus();
          }
        });
      });

      console.log("[BLOCK] who-we-serve initialized with", tabs.length, "tabs");
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWhoWeServe);
  } else {
    initWhoWeServe();
  }
})();
